var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoToEssilorTabletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5925_52247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.707 20.875L19.694 16.862L22.348 14.208C22.868 13.688 22.6675 12.803 21.9735 12.558L9.3935 8.118C9.279 8.0775 9.1655 8.059 9.0555 8.059C8.4025 8.059 7.8785 8.7155 8.1175 9.394L12.5575 21.974C12.7085 22.4015 13.102 22.6415 13.5035 22.6415C13.754 22.6415 14.0075 22.548 14.2075 22.348L16.8615 19.694L20.8745 23.707C21.0705 23.9025 21.3265 24 21.582 24C21.8375 24 22.094 23.9025 22.289 23.707L23.707 22.289C24.0975 21.8985 24.0975 21.2655 23.707 20.875ZM21.582 23L16.862 18.28L13.501 21.641L9.068 9.0635L21.6415 13.501L18.2805 16.862L23 21.582L21.582 23Z",
    fill: "#031434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0H9V4.5H10V0Z",
    fill: "#031434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9H0V10H4.5V9Z",
    fill: "#031434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85343 2.14638L2.14633 2.85348L5.64612 6.35327L6.35322 5.64617L2.85343 2.14638Z",
    fill: "#031434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5925_52247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToEssilorTabletIcon);
export default __webpack_public_path__ + "static/media/go_to_essilor_tablet_icon.93e1ffedcd71b7a954099cae4d9195c0.svg";
export { ForwardRef as ReactComponent };